import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { SearchedUser } from '@backrs_ui/grow-ui/src/models/models';

import { logout } from '../session/logoutThunk';

type UserInput = Readonly<
  | {
      type: 'SINGLE_INPUT';
      value: string;
    }
  | {
      type: 'MULTIPLE_INPUT';
      value: string[];
    }
  | {
      type: 'MULTIPLE_INPUT_MAP';
      value: Record<string, string>;
    }
>;

type SolutionSessionState = Readonly<{
  userMessage: string;
  inputBoxMessage: string;
  chatMode: boolean;

  userInput?: UserInput;

  userSearchResults: SearchedUser[];
  customPrompt: string;

  loading: boolean;
  error?: string;
}>;

export const initialState: SolutionSessionState = {
  loading: true,

  userMessage: '',
  inputBoxMessage: '',
  chatMode: false,
  userSearchResults: [],
  customPrompt: '',
};

export const solutionSessionSlice = createSlice({
  name: 'solutionSession',
  initialState,
  reducers: {
    setUserMessage: (state, action: PayloadAction<string>) => {
      state.userMessage = action.payload;
    },
    setInputBoxMessage: (state, action: PayloadAction<string>) => {
      state.inputBoxMessage = action.payload;
    },
    setChatMode: (state, action: PayloadAction<boolean>) => {
      state.chatMode = action.payload;
    },
    setUserInput: (state, action: PayloadAction<UserInput | undefined>) => {
      state.userInput = action.payload;
    },
    setUserSearchResults: (state, action: PayloadAction<SearchedUser[]>) => {
      state.userSearchResults = action.payload;
    },
    setCustomPrompt: (state, action: PayloadAction<string>) => {
      state.customPrompt = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // LOGOUT
      .addCase(logout, (state) => {
        state.loading = false;
        state.error = undefined;
      });
  },
});

export const {
  setUserMessage,
  setInputBoxMessage,
  setChatMode,
  setUserInput,
  setUserSearchResults,
  setCustomPrompt,
} = solutionSessionSlice.actions;

// Reducer
export const solutionSessionReducer = solutionSessionSlice.reducer;

// Selectors
// only add selectors when you need them to do some sort of logic. Otherwise, just use the state directly
